import { useCallback } from 'react';
import { notificationMarkViewedMutation } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useGraphqlClient } from './useGraphqlClient';

export const useNotificationViewed = () => {
    const graphqlClient = useGraphqlClient();

    return useCallback(
        (feedbackToken: string) => {
            graphqlClient.fetch({
                operation: notificationMarkViewedMutation,
                variables: feedbackToken
                    ? {
                          feedbackToken,
                      }
                    : undefined,
            });
        },
        [graphqlClient]
    );
};
